const actions = {
  SET_STATE: "SET_STATE",
  GET_CURRENT_USER: "GET_CURRENT_USER",
  AUTH_USER: "AUTH_USER",
  RESET_PASSWORD: "RESET_PASSWORD",
  GET_PLANS: "GET_PLANS",
  DISABLE_USER: "DISABLE_USER"
}

export default actions;
